<script setup>
import { usePage } from '@inertiajs/inertia-vue3'
import { computed, inject } from 'vue'

import ButtonToggle from '@/Components/Forms/ButtonToggle.vue'
// eslint-disable-next-line import/extensions
import { trans } from '@/Translate'

import useCart from '../useCart.js'

const cart = useCart(inject('cart'))
const checkoutOptions = inject('checkoutOptions')
const paypalSubscriptionsEnabled = inject('paypalSubscriptionsEnabled')

const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  modelValue: String,
  isBusy: {
    type: Boolean,
    default: false,
  },
})

const showToggle = computed(() => {
  if (cart.isLeadMagnetOrOneHundredPercentDiscount() || usePage().props.value?.isTestMode) {
    return false
  }
  if (cart.isSubscription() && cart.isUsageBased()) {
    return false
  }
  if (cart.isSubscription() && !paypalSubscriptionsEnabled.value) {
    return false
  }

  return true
})
</script>

<template>
  <div v-if="cart.isLeadMagnetOrOneHundredPercentDiscount()">
    <template v-if="checkoutOptions.embed">
      <p class="mb-2 text-center text-balance">
        {{ $t('lemonsqueezy_checkout.free_product.want_for_free') }}
        {{ $t('lemonsqueezy_checkout.free_product.enter_email') }}
      </p>
    </template>
    <template v-else>
      <h2 class="mb-1 text-24 font-medium">
        {{
          /* translators: If it's a free product we ask for email address to send the product to. This represents a title of the email collection section. */
          $t('lemonsqueezy_checkout.free_product.want_for_free')
        }}
      </h2>
      <p class="mb-5">
        {{
          /* translators: If it's a free product we ask for email address to send the product to. The input field is below. */
          $t('lemonsqueezy_checkout.free_product.enter_email')
        }}
      </p>
    </template>
  </div>
  <ButtonToggle
    v-if="showToggle"
    :model-value="props.modelValue"
    class="mb-4"
    :disabled="props.isBusy"
    :options="[
      // translators: Button that lets you choose paying by card (or PayPal)
      { key: 'card', label: trans('lemonsqueezy_checkout.pay_by_card') },
      // translators: Toggle button that lets you choose paying with PayPal (or card)
      { key: 'paypal', label: trans('lemonsqueezy_checkout.pay_with_paypal') },
    ]"
    @update:model-value="(value) => emit('update:modelValue', value)"
  />
</template>
